import backend from '@/services/backend'

export default {

    fetchStructure (authToken, realmName) {
        return backend.get('realm/structure/' + realmName, { headers: { Authorization: authToken }} )
    }

}
